const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const createReviewCorrectiveActionMachine = ({
  correctiveAction,
  token,
  qmsToolApiUrl,
}) =>
  createMachine(
    {
      /** @xstate-layout N4IgpgJg5mDOIC5QCcwDcCWYDuBaAxgPbKr4AuGaYuAhuRoQHYB0kGFjUAxACICiAZQDCAJQCSABQAqYgPIA5APpCAEgEF5AcT48A2gAYAuolAAHQrHYNGJkAA9EuAEwA2ACzMAnAFYA7J5cAZidPN08nAA43bwAaEABPRCDmbwBGX2CXVM8IrJ9AgF8CuNRMHAJiUgoqWnomVggrTi4BKTUpAFUBZXUtHQNjJBBzSwomWwcEZzdA5kDvALTXfRC3F184xIQnfQ9vaMDUrP1AtbcMopL0LDwiEjB6GroxljYObl6eABk+EUUpACaEj4PQ02j0RlsIys4yGk30m0Q+kuIFKNwq90e1Ge1gaTW4fAAGhIxCJ2nIlDx2iCBHwfkIpP1IUNoS8Jo5IrMdvojhF5hlfE43IiEKdfMwXPoIidvBFfBEnPLfL4UWjyncqpRsXVXo13rxZABZNRiJS0+mMiGDMwWGE2OEctbMXz6cKy1LRPkLDYJRyeVLMVKpXK+NxS-QuCLZQrFVHXdWVB7VbUvPH6iQiWQAIR+hsUrWphr48ikoL6VqhtrZDqmIQizvCxyFnmCTicsV9CH8nglPmD0R8J1Oqvjt0TWNqqbeGGamdkpaEai6INUYKZ1uGVes7NryRyaxcLbcTmyIvc3i83kjgsCLdDHpHZTHmOTk9x0+aHQkVMZiizfDUERfn+WQAGliwGStRm3GtUlOFJI0yaUnFOaIXBFXBlWYKM4N8BY3AiKJDycR90Q1JMtTfeoP24fgfkZSCWS3WFQEmQIVjmVJdn0e84KyNxhU7Twe08F0BIVUJPB4gjSITF9KJxai9Rnbgvx-PhGJtaCWPsRBAkFCUI1yFDFUCFwOy2SIezbRVziCdx5hmWTn01J4dTTFSuCEWQRCAhkxAANRBNR-IUfNZA6EQhBpOk+AZdcoLtHdcECdjmH0GVXVDdxIwiEU+2YNYI28KU-FlQ5nIxVyU3fZTmm83y4pkILFBCmQwozORxEBfNYviismO0+1WMcVKPGlBUpSCKSMk8EUuICOZIgEk51mIlxKvIidFN1fFeD4AAxX4yS+RQgLUAQwtXctNM3IbkrSHtg0CCbCKVeYRRK8VfBcQ8CKibx9O8Tbx1fHbmAgMAABswDIMAIeh2HPIgJh4ZnNBCAAa3htUXIotzU0hmG4YR4mVIQdHCHwGgXgGW7WRgkau1vLwhUFIUXCFNxgxFdinAlMJglSNtg1yYdY1xqr8Zq+oidh+G5f1MASGIZhTChmmADNiAAW2YSWtrB9zFYVxH3gpxgMep2mjHp5jht0hAuNcZ15W51L2N2Qj5tElIvWVMNXAiHJgYl0cpe242zdNsnmjsWAyBp+GaE1uHkAACi4jL9AASi4A3QYUqPiZjpHODt+7YJ42ZSv9IIg3OKV5tdLxgmlfxOZKnY3BB+SCdxE3WBV5BmHwAALB5MYAAmV5BiCnsh4lMMAuArpLYLG519n0nYxWDwStlOesfF8dJOd37xvBIsOnwjo3Cejoe55H8fJ5n4eF6XlfdFSDcGZ0yYRxdiGXWKJCMItua8wIpeU+CxiJwTKr3aqVEWCD1nqrOg+A4CwCnpDRgWAIBeQ0NFL4a9qxMyDPKZgNlDjtmDkGYWIpG7YTlHBfSGR1gXBvmRQu-dZaP3QSPWAysqDIHfs-LgQEpAiABGQxmjsFoXjlL9XIV8ox+B9IfK+MC4LhAElJQ8SDpYoOYAAV1MBAJOZiLE02RqjZglNsb63DobIuqZzGWJJh42xnALZW1sUwOmzItLryZm2b6nDFTZUBqVEUhF6xXiKucTIngjGR3cTYrxmTPKCLVhrMg2tkB6wLn3GWLBvFZM8eTSm1trBBL-vbHcl96zrFMmkEql9foilPvWHYWQyrCXWPMNJ99cQVPhoIyRfBpGyOCXdUJjt3ABlSmkNh8xnboU7B3OY541jzFbKkUOVxb6uL4eUzJEzh6jwnvgaegjP7L1XnM-+DtJgzUKockIipgx+ByHE-whV9iKklDKUyIy3FjIuU-VWr9bniPnovR5P8GmVwoTsAM0ohlHg9EKf5PZojHh+hleYYLuFyWQeDcZhC5EAMcL8hsawXRSmiIDA+iB-TYWyFJWU3y1ih1jIwQgkN4BDBKRSnUiVyGO1wJzb6oR1gZQBqyjC6QWnBkjLhCIV90ipLJXjdJtV8SSvkZMBYgYXorCkjyKI2URSKn5u6NILp8hexjMcnhpSTEm2NbShA6x6wRjDLKE4wZZp2v5jMSIGVfoHhPBEcFZzSbyyTe8H1rzECChcOldw+hg2HDlLeeaWFDnmSklGY8LYjlxhObwspKbLnPzTTuYWuQt4zEFCcc4+95raIElfUFaxgwtgTXWtBVzYV3I-oisATaN5pBSLml0tCAiaMQChES0QTxSjbJ6BUI6vUCKuZg7BuCwD4MgLOih8x6xyjlFfTmY1IxMJbpfXY8pTJcRtfu8GY7n7MGEcgUR8LkCXoUVkLkkkOH2U2VsMMPZX1do-cy79xd5YQFA5MU+PZpRcTwocfNkDOwzFmAqUMgNbxOq4e68lxjKUXIw2uyI2FAaRjsoOvkTgzwRnSgeIICwpTBlSChjJnj4YVJUgx7YP1mNmRtTlZ6Z4WwpAPC6eJ5l-DCchaJ6FIHBoLMmFq-Fnzwg9N+XlLZhzLyul5MGNmbrq0evFSJqxuSJ3AYeTOvTUq3kemdFq4W-afBrHM1saUsxoiuiFEGSUrDNP1HGTp5gx7YA4LwQQyT4R+aHKjJEbIHpuacaEusahYRRJ7IjH9OL5ztO5IA0BwRknhZcUKpJHdRwXotnysV5sLZIztMIhtPVd8IXxYuehrzJq10ukDNKNIcpogB1xZ2JrGLK2A2VFEniRQihAA */
      id: "review-corrective-action",

      predictableActionArguments: true,
      context: {
        changes: new Set(),
        correctiveAction: correctiveAction,
        authentication: { token: token },
        qmsToolApiUrl: qmsToolApiUrl,
      },
      states: {
        editing: {
          on: {
            DESCRIPTION_CHANGED: {
              target: "editing",
              internal: true,
              actions: ["saveDescription", "flagChanges"],
            },

            STATUS_CHANGED: {
              target: "editing",
              internal: true,
              actions: ["saveStatus", "flagChanges"],
            },

            HANDLER_TYPE_CHANGED: {
              target: "editing",
              internal: true,
              actions: ["saveHandlerType", "flagChanges"],
            },

            EXPIRATION_DATE_SELECTED: {
              target: "editing",
              internal: true,
              actions: [
                "saveExpirationDate",
                "flagChanges",
                "flagDeferralReasonAsMandatory",
              ],
            },

            DOMAIN_SELECTED: {
              target: "editing",
              internal: true,
              actions: ["saveDomain", "flagChanges"],
            },

            PROBLEM_STATEMENT_CHANGED: {
              target: "editing",
              internal: true,
              actions: ["saveProblemStatement", "flagChanges"],
            },

            ROOT_CAUSE_CHANGED: {
              target: "editing",
              internal: true,
              actions: ["saveRootCause", "flagChanges"],
            },

            UPDATE_BEARER_TOKEN: {
              target: "editing",
              internal: true,
              cond: "validToken",
              actions: "saveToken",
            },

            DELETE: {
              target: "delete",
              cond: "noReportOrReportDraftOrPending",
            },

            UPDATE: {
              target: "update",
              cond: "validChangeSet",
            },

            CORRECTIVE_ACTION_SOURCE_SELECTED: {
              target: "editing",
              internal: true,
              actions: ["saveCorrectiveActionSource", "flagChanges"],
            },

            CORRECTIVE_ACTION_PRIORITY_SELECTED: {
              target: "editing",
              internal: true,
              actions: ["saveCorrectiveActionPriority", "flagChanges"],
            },

            DEFERRAL_REASON_CHANGED: {
              target: "editing",
              internal: true,
              actions: ["saveDeferralReason", "flagChanges"],
            },
          },
        },

        delete: {
          states: {
            deleting: {
              invoke: {
                src: "deleteCorrectiveAction",
                onDone: "#review-corrective-action.deleted",
                onError: {
                  target: "error",
                  actions: "saveError",
                },
              },

              after: {
                10000: "error",
              },
            },

            error: {
              states: {
                "check error type": {
                  always: [
                    {
                      target: "access denied",
                      cond: "accessDeniedError",
                    },
                    "server error",
                  ],
                },

                "access denied": {
                  on: {
                    CANCEL: "#review-corrective-action.editing",
                  },
                },
                "server error": {
                  on: {
                    RETRY: "#review-corrective-action.delete.deleting",
                  },
                },
              },

              initial: "check error type",
            },
          },

          initial: "deleting",
        },

        deleted: {
          type: "final",
          entry: "sendDeleteEventToParent",
        },

        update: {
          states: {
            updating: {
              invoke: {
                src: "updateCorrectiveAction",
                onDone: {
                  target: "#review-corrective-action.updated",
                  actions: [
                    "unflagChanges",
                    "updateCompletionDateIfNecessary",
                    "emptyChanges",
                    "unflagDeferralReasonAsMandatory",
                  ],
                  description: `This transition, the action "updateCompletionDateIfNecessary", has been assigned to this transition so that we can save the completion date, whatever it is. This is a very, very minimal delta update that is done by the backend.`,
                },
                onError: {
                  target: "error",
                  actions: "saveError",
                },
              },
            },

            error: {
              on: {
                RETRY: "updating",
              },

              states: {
                "check error type": {
                  always: [
                    {
                      target: "access denied",
                      cond: "accessDeniedError",
                    },
                    "server error",
                  ],
                },

                "access denied": {},
                "server error": {},
              },

              initial: "check error type",
            },
          },

          initial: "updating",
        },

        updated: {
          entry: "sendUpdateEventToParent",

          always: "editing",
        },
      },

      initial: "editing",
    },
    {
      actions: actions,
      guards: guards,
      services: services,
    },
  );

export { createReviewCorrectiveActionMachine };
